import ExitTrigger from '@mvps-genesis/exit-trigger';
import Checkout from 'extensions/checkout/Checkout.js';
import 'extensions/checkout/checkout.scss';
import 'extensions/proforma/components/x-proforma';
import 'extensions/ui-components/x-file-uploader';
import 'extensions/ui-components/x-file-uploader-input';
import {PageManager} from 'genesis-packages/core';
import './OPAY.scss';

export default class OPAY extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		new ExitTrigger('.js-exit-trigger', {
			message: 'Are you sure you want to exit checkout?',
			redirectUrl: this.pageContext.Basket_Url
		});

		new Checkout();

		const opayForm = document.getElementById('js-opay-form');
		if (opayForm) {
			// Prevent re-enabling the button if ProForma
			if (!document.getElementsByTagName('x-proforma')) {
				this.resetButtons(opayForm);
			}
			opayForm.addEventListener('submit', () => this.handleSubmit(opayForm));
		}
	}

	handleSubmit (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		const loadingText = 'Loading...';

		if (buttons) {
			for (const button of buttons) {
				button.disabled = true;

				if (button.nodeName === 'INPUT') {
					button.setAttribute('data-original-text', button.value);
					button.value = loadingText;
				} else {
					button.setAttribute('data-original-text', button.innerText);
					button.innerText = loadingText;
				}
			}
		}
	}

	resetButtons (form) {
		const buttons = form.querySelectorAll('[type="submit"]');
		if (buttons) {
			for (const button of buttons) {
				const originalText = button.getAttribute('data-original-text');
				button.disabled = false;

				if (!originalText) {
					continue;
				}

				if (button.nodeName === 'INPUT') {
					button.value = originalText;
				} else {
					button.innerText = originalText;
				}
			}
		}
	}

};
